<div
  class="backgroundSurfaceDs__cont backgroundSurfaceDs__cont--{{type}}"
  [class.box-shadow]="boxShadow"
  [ngStyle]="{
    height: height,
    width: width,
    position: position,
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    padding: padding,
    margin: margin,
    borderRadius: borderRadius
  }">
  <ng-content></ng-content>
</div>